import config from '@epi-config';
import { get } from '@epi-helpers/FetchHelpers';
import { ITransactionEstimate } from '@epi-models/containers/LoadCompanyAccount';
import emptyApi from '@epi-api/emptyApi';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { GET_TRANSFER_MONEY_ESTIMATION_API_TAG } from '@epi-api/apiTags';

export const getTransferMoneyEstimation = async (): Promise<
  | {
      data: ITransactionEstimate;
    }
  | { error: FetchBaseQueryError }
> => {
  try {
    const data: ITransactionEstimate = await get(
      `${config.apiHost}/api/deposit-orders/estimation`
    );
    return { data };
  } catch (error) {
    return { error: error as FetchBaseQueryError };
  }
};

export const companyAccountApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getTransferMoneyEstimation: build.query<ITransactionEstimate, void>({
      queryFn: getTransferMoneyEstimation,
      keepUnusedDataFor: 1800,
      providesTags: [GET_TRANSFER_MONEY_ESTIMATION_API_TAG]
    })
  })
});

export const {
  useLazyGetTransferMoneyEstimationQuery,
  useGetTransferMoneyEstimationQuery
} = companyAccountApi;
